import { Injectable } from '@angular/core';
import { Http, HttpModule, Headers, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { environment } from "environments/environment";
import { Observable } from 'rxjs/Rx';
import { AccountService } from "app/account/account.service";

@Injectable()
export class RestService {
  public sessionId = 'Empty';

  constructor(private _accountService: AccountService, private _http: Http) {
    this._accountService.authToken.subscribe((token) => {
      this.sessionId = token;
    });
  }

  post(url, body?) {
    return this._http.post(url, body, this.buildOptions())
      .map(res => res.json())
      .toPromise()
      .catch(this.handleError);
  }

  get(url) {
    return this._http.get(url, this.buildOptions())
      .map(res => res.json())
      .toPromise()
      .catch(this.handleError);
  }

  buildOptions() : RequestOptionsArgs {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + this.sessionId);
    return { headers: headers };
  }

  handleError (error) {
    let errMsg = error.message ? error.message : error.toString();
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}


// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/webservice/rest.service.ts